let cache = [];

function importAll(r) {
    r.keys().forEach(key => {
        console.log(r(key));
        cache = cache.concat(r(key));
    });
}

importAll(require.context('.', true, /store\.js$/));

let routes = {};
cache.forEach(r => {
    let obj = r.default;
    routes[obj.name] = obj;
});


export default routes;
